/**
 * Preferência de tema do usuário (API + local).
 * Valores sempre string: "light" | "dark". Padrão da API: "light".
 */

export const THEME_STORAGE_KEY = "vert-color-theme";
export const THEME_DARK = "dark";
export const THEME_LIGHT = "light";

/** Normaliza qualquer valor para "light" | "dark" (default light). */
export function normalizeTheme(value) {
  return value === THEME_DARK ? THEME_DARK : THEME_LIGHT;
}

/** Lê tema do localStorage; se ausente/inválido, retorna "light". */
export function readStoredTheme() {
  if (typeof window === "undefined") return THEME_LIGHT;
  try {
    return normalizeTheme(window.localStorage.getItem(THEME_STORAGE_KEY));
  } catch {
    return THEME_LIGHT;
  }
}

/** Aplica tema no documento (anti-flash / sync fora do React). */
export function applyThemeToDocument(theme) {
  const next = normalizeTheme(theme);
  if (typeof document === "undefined") return next;
  document.documentElement.dataset.theme = next;
  document.documentElement.style.colorScheme = next;
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, next);
  } catch {
    /* ignore */
  }
  return next;
}

/** Extrai theme da resposta de login (root), com fallback light. */
export function themeFromAuthResponse(data) {
  return normalizeTheme(data?.theme);
}
